<template>
    <div>
      <v-card class="main-card rounded-lg pa-6 mb-6">
        <div class="d-flex align-center justify-space-between mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-arrow-right</v-icon>
            <h2 class="text-h5 font-weight-medium primary--text">{{ providers ? providers.length : 0 }} Fornitori</h2>
          </div>
          <v-btn
            color="primary"
            text
            @click="addProvider"
            class="px-4"
          >
            <v-icon left>mdi-plus</v-icon>
            Aggiungi Fornitore
          </v-btn>
        </div>

        <v-data-table
            v-if="providers"
            :headers="headers"
            :items="providers"
            :items-per-page="dtOptions.itemsPerPage"
            :page.sync="dtOptions.page"
            hide-default-footer
            class="elevation-0"
        >
              <template #item.actions="{ item }">
                <div class="d-flex justify-center">
                  <v-btn
                    icon
                    x-small
                    color="primary"
                    class="mr-1"
                    @click="editProvider(item)"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="deleteProvider(item)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
          </v-data-table>

          <custom-pagination
            v-if="providers && totalPages > 0"
            v-model="dtOptions.page"
            :total-items="providers ? providers.length : 0"
            :items-per-page="dtOptions.itemsPerPage"
            @update:items-per-page="updateItemsPerPage"
          ></custom-pagination>
      </v-card>

      <!-- Modali -->
      <provider-dialog
          v-if="showProviderDialog"
          v-model="showProviderDialog"
          :provider-id="selectedProviderId"
          @providerSaved="onProviderSaved"/>
      <provider-delete-dialog
          v-if="showProviderDeleteDialog"
          v-model="showProviderDeleteDialog"
          :provider-id="providerIdToDelete"
          @confirmed="loadProviders()"/>
    </div>
</template>

<script>
import {format, parseISO} from "date-fns";
import ProviderDeleteDialog from "./ProviderDeleteDialog.vue";
import ProviderDialog from "./ProviderDialog.vue";
import CustomPagination from "../../components/widgets/CustomPagination";

export default {
    components: {
        ProviderDeleteDialog,
        ProviderDialog,
        CustomPagination
    },
    data: () => ({
        providers: null,
        showProviderDialog: false,
        selectedProviderId: null,
        providerIdToDelete: false,
        showProviderDeleteDialog: false,
        dtOptions: {
            page: 1,
            itemsPerPage: 10
        },
    }),
    computed: {
        headers() {
            return [
                {value: 'name', text: 'Nome', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'organization_name', text: 'Azienda', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'emails[0].email', text: 'Email', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'emails[0].phone', text: 'Telefono', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'send_file_description', text: 'Descrizione invio file', class: "primary--text font-weight-medium", align: 'start'},
                {value: 'actions', text: 'Azioni', class: "primary--text font-weight-medium text-center", align: 'center', sortable: false}
            ]
        },
        totalPages() {
            if (!this.providers) return 0;
            return Math.ceil(this.providers.length / this.dtOptions.itemsPerPage);
        }
    },
    mounted() {
        this.ensureUserInStore().then(() => {
            if (this.$store.state.user.role === 'MANAGEMENT_CONTROL') {
                this.$router.push({name: 'tasks'});
            }
        })
        this.loadProviders()
    },
    methods: {
        addProvider() {
            this.selectedProviderId = null
            this.showProviderDialog = true
        },
        deleteProvider(item) {
            this.providerIdToDelete = item.id
            this.showProviderDeleteDialog = true
        },
        editProvider(item) {
            this.selectedProviderId = item.id
            this.showProviderDialog = true
        },
        formatDate(isoDate) {
            return isoDate ? format(parseISO(isoDate), 'dd/MM/yyyy') : ''
        },
        loadProviders() {
            this.$providerService.list().then(
                response => {
                    this.providers = response.data;
                }
            )
        },
        onProviderSaved() {
            this.showProviderDialog = false
            this.loadProviders()
        },
        ensureUserInStore() {
            if (!this.$store.state.user) {
                return this.$store.dispatch('setCurrentUser');
            } else {
                return Promise.resolve();
            }
        },

        updateItemsPerPage(itemsPerPage) {
            this.dtOptions.itemsPerPage = itemsPerPage;
            this.dtOptions.page = 1; // Torna alla prima pagina quando cambia il numero di elementi per pagina
        }
    }
}
</script>
<style>
/* Utilizziamo gli stili globali definiti in custom.css */
</style>
